export default __webpack_public_path__ + "static/media/icon_help_outline.304aa1e9.svg";